<template>    
    <div v-if="required" class="col-12 px-0 form-group">
        <label :for="name" class="col-12 px-0">{{labels.accountNumber}}</label>
        <div class="input-group">
            <input v-if="!shown" class="form-control" v-bind:class="{'error': needToShowError}" aria-required="true" ref="accountNumInput" maxlength="11" :id="name" :name="name" type="password" inputmode="numeric" v-model="value" @blur="onAccountNumberBlur" v-maska="maskValue">
            <input v-else class="form-control" ref="accountNumInput" v-bind:class="{'error': needToShowError}" aria-required="true" maxlength="11" :id="name" :name="name" type="text" inputmode="numeric" v-model="value" @blur="onAccountNumberBlur" v-maska="maskValue">
            <div class="input-group-append">
                <button class="input-group-text icon-button" @click="toggleDisplay" type="btton" role="switch" :aria-pressed="String(shown)" v-tooltip="shown ? 'Hide account number' : 'Show account number'">
                    <fa-icon v-if="!shown" :icon="['fas','eye-slash']" class="theme-primary" />
                    <fa-icon v-else :icon="['fas','eye']" class="theme-primary" />
                    <span class="sr-only">Show or hide account number</span>
                </button>
            </div>
        </div>
        <p v-if="needToShowError" class="error-msg mt-2" role="alert" aria-live="assertive"><fa-icon :icon="['fas', 'exclamation-triangle']" class="mr-1" />{{labels.accountNumberErrorMsg}}</p>
    </div>
</template>

<script>
    export default {
        name: "AccountNumber",

        emits: ['set-account-number'],

        props: {
            labels: Object,
            name: String,
            required: Boolean
        },

        data: function() {
            return {
                value: "",
                shown: true,
                maskValue: "###########",
                inError: false,
                showError: false
            }
        },

        methods: {
            toggleDisplay: function() {
                this.shown = !this.shown;
            },

            setInError: function() {
                this.inError = this.value === "";
            },

             onAccountNumberBlur: function() {
                this.showError = true
                this.setInErrorAndEmitValue();
            },

            setInErrorAndEmitValue: function() {
                this.setInError();
                this.$emit('set-account-number', !this.inError ? this.value : "");
            },

            clear: function() {
                this.value = "";
            },

            setFocus: function() {
                this.$refs.accountNumInput?.focus();
            }
        },

        watch: {
            value: function(val) {
                this.showError = false;
                this.setInErrorAndEmitValue();
            }
        },

        computed: {
            needToShowError: function() {
                return this.inError && this.showError;
            }
        }
    }
</script>